// extracted by mini-css-extract-plugin
export default {"wrapper":"Banner_wrapper__5tGFE","banner":"Banner_banner__vYwRw"};